import { getLogger } from '@olympeio/core';
import { Brick, registerBrick, BrickContext } from 'olympe';

export default class CheckDisabledMassEditBasedOnFiltersCoded extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} selectedFilters
     * @param {*} operationType
     * @param {function(boolean):void} setDisabled
     */

    update($, [selectedFilters, operationType], [setDisabled]) {
        const logger = getLogger('CheckDisabledMassEditBasedOnFiltersCoded');

        const hasEmptyProperty = (object, properties) => {
            for (let i = 0; i < properties.length; i++) {
                const prop = properties[i];
                if (
                    !Object.prototype.hasOwnProperty.call(object, prop) ||
                    !Array.isArray(object[prop]) ||
                    object[prop].length > 0
                ) {
                    return false;
                }
            }
            return true;
        };
        if (operationType === 'PR') {
            setDisabled(
                hasEmptyProperty(selectedFilters, [
                    'agents',
                    'approvers',
                    'costCenters',
                    'personRespId',
                    'internalWBS',
                    'wbs',
                ])
            );
        } else if (operationType === 'PO') {
            setDisabled(hasEmptyProperty(selectedFilters, ['agents', 'approvers', 'purchasingGroup']));
        } else {
            logger.error('ERROR: Operation Type is Unkown');
        }
    }
}

registerBrick('0191dae784977c418fc8', CheckDisabledMassEditBasedOnFiltersCoded);
